module.exports = __webpack_public_path__ + "static/media/noun-shuffle-2785513.aabe238b.svg";